async function bulkImportShapeFileRequest(url = '', data = {}, apiKey, signal) {
  const response = await fetch(url, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'x-api-key': apiKey
      //'Content-Type': 'multipart/form-data; boundary=MyBoundary'
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: data,
    signal
  })

  const responseJson = await response.json()

  if (responseJson.redirect) {
    window.location.href = window.location.origin + responseJson.redirect
    return {}
  }

  // Include the HTTP status in the response to help with error handling
  return {
    ...responseJson,
    status: response.status
  }
}

export default bulkImportShapeFileRequest
